var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cancel_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cancel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.054l3.073 3.073c.138.138.313.21.522.212a.707.707 0 00.532-.212.717.717 0 00.217-.527.717.717 0 00-.217-.527L13.054 12l3.073-3.073a.725.725 0 00.212-.522.707.707 0 00-.212-.532.717.717 0 00-.527-.217.717.717 0 00-.527.217L12 10.946 8.927 7.873a.725.725 0 00-.522-.212.707.707 0 00-.532.212.717.717 0 00-.217.527c0 .206.072.382.217.527L10.946 12l-3.073 3.073a.725.725 0 00-.212.522.707.707 0 00.212.532c.145.145.32.217.527.217a.717.717 0 00.527-.217L12 13.054zm.002 8.446a9.255 9.255 0 01-3.705-.748 9.596 9.596 0 01-3.018-2.03 9.591 9.591 0 01-2.03-3.016 9.245 9.245 0 01-.749-3.704c0-1.314.25-2.55.748-3.705a9.597 9.597 0 012.03-3.017 9.592 9.592 0 013.016-2.032 9.245 9.245 0 013.704-.748c1.314 0 2.55.25 3.705.748a9.597 9.597 0 013.018 2.03 9.592 9.592 0 012.03 3.016 9.245 9.245 0 01.749 3.704c0 1.314-.25 2.55-.748 3.705a9.597 9.597 0 01-2.03 3.018 9.592 9.592 0 01-3.016 2.03 9.247 9.247 0 01-3.704.749zM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20z",
    fill: "#8E8E94"
  }))));
}
export default SvgCancel;